import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";
import { Container, Form, Button, Row, Col, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import StocCurentPickerModal from "../pickers/StocCurentPickerModal";

const TransferObInvForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [formData, setFormData] = useState({
    doc_no: "",
    doc_date: new Date().toISOString().split("T")[0],
    gestiune_id: "",
    angajat_sursa_id: "",
    angajat_dest_id: "",
    details: [],
  });

  const [gestiuni, setGestiuni] = useState([]);
  const [angajati, setAngajati] = useState([]);

  // For the product picker
  const [pickerShow, setPickerShow] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);

  useEffect(() => {
    // Load lookups
    api.get("/bxgestiune/?limit=1000").then(res => setGestiuni(res.data.items || res.data)).catch(console.error);
    api.get("/angajati/").then(res => setAngajati(res.data)).catch(console.error);

    if (isEdit) {
      api.get(`/obinv/transfer/${id}`).then((res) => {
        setFormData({
          doc_no: res.data.doc_no || "",
          doc_date: res.data.doc_date || "",
          gestiune_id: res.data.gestiune_id || "",
          angajat_sursa_id: res.data.angajat_sursa_id || "",
          angajat_dest_id: res.data.angajat_dest_id || "",
          details: res.data.details || [],
        });
      }).catch(console.error);
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDetailChange = (index, field, value) => {
    const newDetails = [...formData.details];
    newDetails[index][field] = value;
    setFormData((prev) => ({ ...prev, details: newDetails }));
  };

  const addDetail = () => {
    setFormData((prev) => ({
      ...prev,
      details: [
        ...prev.details,
        { bxpart_id: "", qty: 1, pret: 0 },
      ],
    }));
  };

  const removeDetail = (index) => {
    const newDetails = formData.details.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, details: newDetails }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...formData };
    const fieldsToClean = ["gestiune_id", "angajat_sursa_id", "angajat_dest_id"];
    fieldsToClean.forEach(f => {
      if (payload[f] === "") payload[f] = null;
    });

    if (payload.angajat_sursa_id === payload.angajat_dest_id) {
      toast.error("Angajatul sursă și cel destinație nu pot fi identici!");
      return;
    }

    try {
      if (isEdit) {
        await api.put(`/obinv/transfer/${id}`, payload);
        toast.success("Transfer actualizat!");
      } else {
        await api.post("/obinv/transfer/", payload);
        toast.success("Transfer creat!");
      }
      navigate("/obinv/transfer");
    } catch (error) {
      console.error(error);
      toast.error("Eroare la salvare!");
    }
  };

  return (
    <Container className="mt-4">
      <h2>{isEdit ? "Editare Transfer Ob. Inv." : "Adăugare Transfer Ob. Inv."}</h2>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Număr Document</Form.Label>
              <Form.Control type="text" name="doc_no" value={formData.doc_no} onChange={handleChange} required />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Data</Form.Label>
              <Form.Control type="date" name="doc_date" value={formData.doc_date} onChange={handleChange} required />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Gestiune (Opțional)</Form.Label>
              <Form.Select name="gestiune_id" value={formData.gestiune_id} onChange={handleChange}>
                <option value="">-- Selectează Gestiune --</option>
                {gestiuni.map(g => <option key={g.id} value={g.id}>{g.bxcod} - {g.bxnume}</option>)}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Angajat Sursă (Predă)</Form.Label>
              <Form.Select name="angajat_sursa_id" value={formData.angajat_sursa_id} onChange={handleChange} required>
                <option value="">-- Selectează Angajat --</option>
                {angajati.map(a => <option key={a.id} value={a.id}>{a.nume_prenume}</option>)}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Angajat Destinație (Primește)</Form.Label>
              <Form.Select name="angajat_dest_id" value={formData.angajat_dest_id} onChange={handleChange} required>
                <option value="">-- Selectează Angajat --</option>
                {angajati.map(a => <option key={a.id} value={a.id}>{a.nume_prenume}</option>)}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <h4>Obiecte Transferate</h4>
        <Table bordered size="sm">
          <thead>
            <tr>
              <th>Obiect (Produs)</th>
              <th>Cantitate</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            {formData.details.map((detail, index) => (
              <tr key={index}>
                <td>
                  <Button 
                    variant="outline-secondary" 
                    size="sm"
                    onClick={() => {
                      setActiveRowIndex(index);
                      setPickerShow(true);
                    }}
                  >
                    {detail.bxpart_id ? (detail.cod + " - " + detail.denumire) : "Alege Produs..."}
                  </Button>
                </td>
                <td>
                  <Form.Control
                    type="number" step="0.01"
                    value={detail.qty}
                    onChange={(e) => handleDetailChange(index, "qty", e.target.value)}
                    required
                  />
                </td>
                <td>
                  <Button variant="danger" size="sm" onClick={() => removeDetail(index)}>Șterge</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Button variant="secondary" size="sm" onClick={addDetail} className="mb-3">
          + Adaugă Linie
        </Button>
        <br />
        <Button variant="primary" type="submit">Salvează</Button>
      </Form>

      {/* Modal pentru alegere produse */}
      <StocCurentPickerModal
        show={pickerShow}
        gestiuneId={formData.gestiune_id} // optional pt a gasi usor din stoc global
        onHide={() => {
          setPickerShow(false);
          setActiveRowIndex(null);
        }}
        onPick={(picked) => {
          if (activeRowIndex !== null) {
            const newDetails = [...formData.details];
            const raw = picked.raw;
            newDetails[activeRowIndex] = {
              ...newDetails[activeRowIndex],
              bxpart_id: picked.id,
              cod: raw.cod,
              denumire: raw.denumire,
              qty: 1, 
              pret: raw.pret_magazie || 0
            };
            setFormData((prev) => ({ ...prev, details: newDetails }));
          }
        }}
      />
    </Container>
  );
};

export default TransferObInvForm;
